import { Component, ViewChild, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ReportsService } from "../../api/api/reports.service";
import { FacilitiesService, Facility } from "../../core/facilities/facilities.service";
import { ReportResident } from "../../api/model/reportResident";
import { DataTableDef } from "../../shared/datatable/data-table.component";
import { ActivatedRoute, Params } from "@angular/router";
import { SingleFacilitySelectorComponent } from "../../shared/single-facilty-selector/single-facility-selector";
import { Location } from "@angular/common";
import { MedDischargeOrder } from "../../api/model/medDischargeOrder";
import { AbstractDownloadFileContentComponent } from '../../shared/download-file-content/abstract-download-file-content.component';
import { takeUntil } from 'rxjs/operators';

class AdditionalLines {
    label: string;
    selected: boolean;
    value?: number;
}

@Component({
    selector: 'my-medical-discharge-report',
    styleUrls: ['medical-discharge-report.component.scss'],
    templateUrl: 'medical-discharge-report.component.html'
})

export class MedicalDischargeReport extends AbstractDownloadFileContentComponent implements OnInit, AfterViewInit {

    constructor( private reportService: ReportsService,
                 private facilityService: FacilitiesService,
                 private cdr: ChangeDetectorRef,
                 private route: ActivatedRoute,
                 private location: Location){
        super();
        this.initialResidentId = "";
    }
    searchText:string;

    filteredResidents: ReportResident[];
    allPossibleResidents: ReportResident[]=[];

    selectedResident: ReportResident;
    title: string = 'Generate Medication Discharge Summary';

    private initialResidentId;

    screen: number = 1;

    printMonographs: boolean = false;

    lineOptions: AdditionalLines[] = [
        {
            label: 'None',
            selected: true,
            value: 0
        },
        {
            label: 'One',
            selected: false,
            value: 1
        },
        {
            label: 'Two',
            selected: false,
            value: 2
        },
        {
            label: 'Three',
            selected: false,
            value: 3
        },
        {
            label: 'Four',
            selected: false,
            value: 4
        },
        {
            label: 'Five',
            selected: false,
            value: 5
        }
    ]

    selectLines(lines: AdditionalLines){
        this.lineOptions.forEach(x => x.selected = false);
        this.lineOptions.find(x => x.value === lines.value).selected = true;
    }

    selectResident(resident: ReportResident){
        if(this.selectedResident) {
            this.selectedResident.IsSelected = false;
        }

        resident.IsSelected = true;
        this.selectedResident = resident;
    }

    searchResidents(value: string){
        this.filteredResidents = this.allPossibleResidents.filter(r=>
        {
            let lowerCaseName = r.Name.toLowerCase();
            let lowerSearch = value.toLowerCase();
            return lowerCaseName.indexOf(lowerSearch)>=0;
        });
    }

    getResidentById(residentId: string){
        let resident : ReportResident = this.allPossibleResidents
            .find( (f) => { return f.ResidentId == residentId} );
        return resident;
    }

    showForPatient(patientId) {
        this.reportService.reportsGetResidentsForModal(this.facilityService.selectedAsOrgList[0]).subscribe((result) =>
        {
            this.allPossibleResidents = result;
            this.filteredResidents = result;
        });
    }

    ngOnInit() {
        this.route.params.forEach((params: Params) => {
            if(params['id'] && !this.selectedResident) {
                let id =  params['id'];
                this.initialResidentId = id;
                this.location.replaceState('/medical-discharge');
            }
        });

    }

    showWithResidentSelected(residentId) {
        this.initialResidentId = residentId;
    }


    reset(){
        this.searchText='';
        this.searchResidents('');
        if(this.selectedResident){
            this.allPossibleResidents.find(x => x.IsSelected=false);
        }
        this.selectedResident = null;
        this.screen = 1;
        this.selectLines(this.lineOptions.find(x => x.label === 'None'))
        this.printMonographs = false;
    }   

    medOrdersTableDef: DataTableDef = {
        idProperty: 'RxNumber',
        columns: [
            { header: 'Medication', property: 'Medication', width: 230, filterable: false},
            { header: 'Directions', property: 'Directions', width: 370, filterable: false },
            { header: 'Order Type', property: 'RxOtc', width: 110, filterable: false },
            { header: 'Rx Number', property: 'RxNumber', width: 110, filterable: false }
        ],
        columnHeaderLines: 2,
        limit: 1000
    };

    selectedMedications: MedDischargeOrder[];

    medications: MedDischargeOrder[] = null;

    getMedications(){
        this.medications = null;
        this.selectedMedications = null;
        this.screen = 2;
        this.reportService.reportsGetMedOrders(this.facilityService.selectedAsOrgList[0], this.selectedResident.ResidentId).subscribe((result: MedDischargeOrder[])=>{

            this.medications = result;

            this.selectedMedications = [...result];
        });
    }

    pickOptions(){
        this.screen=3;
        let tempMeds = this.medications;
        this.medications = null;
        setTimeout(()=>{
            this.medications = tempMeds;
        })
    }

    back(){
        this.screen = this.screen - 1;
        if(this.screen === 2){
            let tempMeds = this.medications;
            this.medications = null;
            setTimeout(()=>{
                this.medications = tempMeds;
            })
        }
    }

    selectAll(){
        let allSelected = this.selectedMedications.length === this.medications.length;
        if(!allSelected){
            this.selectedMedications = [...this.medications];
        }else{
            this.selectedMedications = [];
        }
    }

    hideSpinner: boolean = true;
    generatePDF(){

        this.hideSpinner = false;

        let x = this.selectedMedications.map(x=>x.RxNumber);
        let selectedMeds = { SelectedMedications: x };

        this.reportService.reportsGetGeneratedMedDischarge(this.selectedResident.ResidentId, this.facilityService.selectedAsOrgList[0], this.lineOptions.find(x=>x.selected).value, this.printMonographs, selectedMeds).subscribe(
            (result) => {
                this.downloadFile(result, 'MedDischargeForm.pdf');
                this.reset();
                setTimeout(()=> this.closeModal());
            }
        );
    }

    closeModal(){
        this.location.back();
        this.ngOnDestroy();
    }

    singleSelectedFacility: boolean = false;

    onSingleSelectedFacility(selectedFacility: Facility){
        this.singleSelectedFacility = true;

        this.facilityService.selectedFacilities$.pipe(takeUntil(this.stop$)).subscribe((facilities) => {
            if(facilities && facilities[0]) {
                this.screen = 1;
                this.allPossibleResidents = this.filteredResidents = null;
                this.selectedResident = null;
                this.reportService.reportsGetResidentsForModal(facilities[0].id).subscribe((result) => {
                    this.allPossibleResidents = result;
                    this.filteredResidents = result;
                    if (this.initialResidentId != "" && this.initialResidentId != null) {
                        let resident = this.getResidentById(this.initialResidentId);
                        this.initialResidentId = "";
                        this.selectResident(resident);
                        let name = resident.Name;
                        this.searchText = name;
                        this.searchResidents(name);
                    }
                });
            }
        });
    }

    ngOnDestroy(){
        this.facilityService.singleSelectedFacilityPage$.next(false);
        super.ngOnDestroy();
    }

    @ViewChild(SingleFacilitySelectorComponent, {static: false}) public singleFacilityModal: SingleFacilitySelectorComponent;

    ngAfterViewInit() {
        this.singleFacilityModal.show();
        this.cdr.detectChanges();
    }
}
